export default image => new Promise(resolve => {
  image.setSize({ max_width: 1280, max_height: 720 })
    .then(file => file.getSize(({ width, height }) => resolve({ src: file.toBlobURL(), alt: file.filename, width, height, file, textAlign: 'center' })))
})
